import {
    TextField,
    InputLabel,
    styled,
    Typography,
    Paper,
    InputAdornment,
} from '@mui/material';
import React, { useMemo } from 'react';
import parse from 'html-react-parser';
import { currencyFormatter } from 'helpers/formatHelper';
import { RetirementSystem } from 'routes/HumanResourcesModule/Settings/HrPositionMapping/helpers/constants';
import { parseNumericInput } from 'helpers/UIHelpers';
import NumberFormatCustom from 'components/NumberFormat/NumberFormatCustom';
import { GENERAL_RATE } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/components/Arrival/helpers/constants';
import Flex from 'ui/Flex/Flex';
import { FormState } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/components/Arrival/AgentArrivalHypothesisModal/AgentArrivalForm';
import { useTranslation } from 'react-i18next';

const StyInputLabel = styled(InputLabel)`
    font-size: 10px;
    margin-top: -20px;
`;

const StyPaper = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.primary.background,
    height: '100%',
}));

type Props = {
    formState: FormState;
    setFormState: React.Dispatch<React.SetStateAction<FormState>>;
    rateCnraclDefaultValue: number;
};
export const AgentArrivalHypothesisThirdStep = ({
    formState,
    setFormState,
    rateCnraclDefaultValue,
}: Props): React.ReactElement => {
    const { t } = useTranslation();
    // if the agent is part of the general system,
    // the ifse amount is taken in account for the loaded salary
    const isCnraclSystem =
        RetirementSystem.CNRACL === formState.retirementSystem;

    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = parseNumericInput(event.target.value);
        setFormState({
            ...formState,
            ifse: newValue || 0,
        });
    };
    const loadedSalary = useMemo(
        () =>
            Math.floor(
                isCnraclSystem
                    ? formState.majoredSalary * (1 + rateCnraclDefaultValue) +
                          formState.ifse
                    : (formState.majoredSalary + formState.ifse) *
                          (1 + GENERAL_RATE),
            ),
        [formState.majoredSalary, isCnraclSystem, formState.ifse],
    );

    return (
        <Flex
            flexDirection="column"
            sx={{
                marginTop: '1em',
                gap: '2em',
            }}
        >
            <StyPaper>
                <Typography sx={{ margin: '1em' }}>
                    {parse(
                        t('humanResources.simulation.addAgent.tbiAmountValue', {
                            value: currencyFormatter(formState.majoredSalary),
                        }),
                    )}
                </Typography>
            </StyPaper>

            <TextField
                variant="outlined"
                value={formState.ifse === 0 ? '' : formState.ifse}
                label={t(
                    'humanResources.simulation.agentHypothesis.ifseAmount',
                )}
                onChange={onChange}
                sx={{ flex: 1 }}
                InputProps={{
                    inputComponent: NumberFormatCustom,
                    startAdornment: (
                        <InputAdornment position="start">€</InputAdornment>
                    ),
                }}
            />
            <StyInputLabel>
                {t('humanResources.simulation.addAgent.loadedSalaryInfo', {
                    loadedSalary,
                })}
            </StyInputLabel>
        </Flex>
    );
};
